<template>
    <div class="modal fade" id="show-extra-info-modal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="generate-pdf-modal-title">
                        {{ $lang('Dodatkowe informacje o bibliotece') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-html="this.dataToPrint"></div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">{{ $lang('Zamknij') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "../../mixins/event-bus";

export default {
    name: "library-extra-info-modal",
    data() {
        return {
            extraInfo: null,
            libraryName: null,
        }
    },
    mounted() {
        EventBus.$on('libraryExtraInfo', (value) => {
            this.libraryName = value.libraryName;
            this.extraInfo = value.extraInfo;
        })
    },
    computed: {
        dataToPrint: function() {
            if (this.libraryName===null && this.extraInfo===null) {
                return 'Pobieranie informacji...';
            } else {
                return '<div class="mb-3"><b>'+this.$lang('Biblioteka:')+'</b><span class="ml-2">' +this.libraryName+
                    '</span></div><div><b>'+this.$lang('Informacje: ') +'</b></div><div class="ml-4">'+this.extraInfo+'</div>';
            }
        }
    },
}
</script>

<style scoped>

</style>
